import React, { Component } from 'react';

export default class ForminputDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            input: "",
            input_value: "",
            input_active: false,
            input_list: [],
            input_dropdown: [],
            highlightedIndex: -1
        };

        this.inputField = React.createRef();

        this.clickInput = this.clickInput.bind(this);
        this.focusInput = this.focusInput.bind(this);
        this.blurInput = this.blurInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.setInputValue = this.setInputValue.bind(this);
        this.showPopupNote = this.showPopupNote.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }


    componentDidMount() {
        if (this.props.default_value != "") {
            this.setState({
                input: this.props.default_value,
                input_list: this.props.list,
                input_dropdown: this.props.list
            });
        }
    }


    componentDidUpdate() {
        if (this.state.input_list !== this.props.list) {
            this.setState({
                input_list: this.props.list,
                input_dropdown: this.props.list
            });
        }
    }


    clickInput() {
        this.inputField.current.focus();
    }


    focusInput() {
        this.setState({
            input_active: true,
            input_value: "",
            input_dropdown: this.props.list
        });
    }


    blurInput() {
        this.setState({
            input_active: false
        });
    }


    handleInputChange(event) {
        var dropdown = this.state.input_list.filter(e => e.toLowerCase().includes(event.target.value.toLowerCase()));
        this.setState({
            input_value: event.target.value,
            input_dropdown: dropdown,
            highlightedIndex: dropdown.length ? 0 : -1,
            input_active: true
        });
    }


    setInputValue(value) {
        this.props.setFormValue(this.props.name, value);
        this.setState({
            input: value,
            input_active: false,
            input_value: value
        });
    }


    showPopupNote() {
        alert(this.props.note);
    }


    handleKeyDown(e) {
        const { input_dropdown, highlightedIndex } = this.state;
        if (!input_dropdown.length) return;

        switch (e.key) {
            case "ArrowDown":
                e.preventDefault();
                this.setState({
                    highlightedIndex: Math.min(highlightedIndex + 1, input_dropdown.length - 1)
                });
                break;
            case "ArrowUp":
                e.preventDefault();
                this.setState({
                    highlightedIndex: Math.max(highlightedIndex - 1, 0)
                });
                break;
            case "Enter":
                e.preventDefault();
                if (highlightedIndex >= 0) {
                    this.setInputValue(input_dropdown[highlightedIndex]);
                }
                break;
            default:
                return;
        }
    }


    render() {
        return (
            <div className={"form__input-container" + (this.props.halfwidth ? " form__input-container--half" : "")}>
                {this.props.label &&
                    <div className="form__input__headline">
                        <div className="form__input__headline__label">
                            {this.props.label}
                        </div>
                        <div className="form__input__headline__infobox">
                            {this.props.required &&
                                <div className="form__input__headline__infobox__icon form__input__headline__infobox__icon--required"></div>
                            }
                            <div onClick={this.showPopupNote} className="form__input__headline__infobox__icon"></div>
                        </div>
                    </div>
                }
                <div onClick={this.clickInput} className={"form__input__dropdown" + (this.state.input_active ? " form__input__dropdown--active" : "")}>
                    <input
                        autoComplete="off"
                        ref={this.inputField}
                        onFocus={this.focusInput}
                        onBlur={this.blurInput}
                        onChange={this.handleInputChange}
                        onKeyDown={this.handleKeyDown}
                        type="text"
                        id={"input_" + this.props.name}
                        name={"input_" + this.props.name}
                        spellCheck="off"
                        value={this.state.input_active ? (this.state.input_value ? this.state.input_value : "") : (this.state.input ? this.state.input : "")}
                        placeholder={(this.props.placeholder && this.props.placeholder != "") ? this.props.placeholder : "Please select"}
                        className="form__input__dropdown__input"
                    />

                    <div className={"form__input__dropdown-container" + (this.state.input_active ? " form__input__dropdown-container--active" : "")}>

                        {this.state.input_dropdown && this.state.input_dropdown.map((e, i) => (
                            <div
                                key={i}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this.setInputValue(e)}
                                className={
                                    "form__input__dropdown__element" + (i === this.state.highlightedIndex ? " form__input__dropdown__element--highlighted" : "")
                                }
                            >
                                {e}
                            </div>
                        ))}

                    </div>


                </div>
            </div>
        )
    }
}
